import { useCallback, useState } from 'react'

import { sendMasterDigest } from '@/api/master'

export function useMasterDigest() {
  const [status, setStatus] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const run = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const payload = await sendMasterDigest()
      const summary = payload?.summary ? 'digest queued' : 'digest generated'
      setStatus(summary)
      return payload
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to send digest')
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return { run, status, error, loading }
}
